import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  field_outlet_name_en: any;
  field_stores_name_ms: any;
  field_stores_name_zh: any;
  field_stores_name: any;
  payload: any;
  id: string;
  field_time_icon: string;
  field_store_main_image: string;
  field_store_description_image: string;
  field_ranking: string;
  field_location_level_name: string;
  field_location_airports: string;
  field_store_time: string;
  field_store_description: string;
  published: boolean;
}

// edit api call
const fetchOutletDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanCMSApi.get(`/api/location-map-stores-data/all-fields/${id}`);
  return response?.data[0];
};

const useOutletDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["outletDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchOutletDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useOutletDocumentDetails };
